/**
 * Bandera del piloto de "Costos y stock" (la UI nueva, v3).
 * ─────────────────────────────────────────────────────────────────────────
 * Decide, por cuenta, si /profile/:uid/:menuId/costs monta el CostsLayout nuevo o el
 * CostsScreen viejo. Los DATOS son los mismos en las dos (product_costs, stock/config,
 * stockMovements): lo único que cambia es la pantalla, así que volver atrás es sacar
 * un uid de la lista y redeployar hosting.
 *
 *  - En desarrollo (npm start) está PRENDIDA para todos: Lucas la prueba en localhost.
 *  - En producción, para TODOS desde el lanzamiento (COSTS_V3_LAUNCH.everyone). Si se apaga,
 *    vuelve a valer sólo para los uid de COSTS_V3_UIDS.
 *  - localStorage "ra.costs.ui" = "v2" | "v3" fuerza una u otra en ESTE navegador. Sirve
 *    para comparar las dos en localhost y, durante el piloto, como salida de emergencia
 *    ("si algo no anda, poné v2 y seguís con la vieja") sin tocar código.
 *  - La POS del local (IS_LOCAL, la sirve el agente) nunca la usa: ahí no hay Costos.
 *
 * Para sumar una cuenta al piloto: pegá su uid (el de Firebase Auth, el mismo que aparece
 * en la URL /profile/<uid>/...) en COSTS_V3_UIDS y deployá hosting. Para lanzarlo a todos,
 * se borra la bandera (isCostsV3 → true) y sus usos, como se hizo con reservas.
 */
import { IS_LOCAL } from "../../comandas/services/localMode";

export const COSTS_V3_UIDS = [];

/* LANZAMIENTO A TODOS (2026-10-09): la UI nueva queda prendida para todos los clientes.
 * Para volver atrás sin tocar nada más: everyone → false (vuelve a mandar COSTS_V3_UIDS) y deploy
 * de hosting. Es un objeto y no un booleano suelto para que los tests puedan probar las dos reglas. */
export const COSTS_V3_LAUNCH = { everyone: true };

export const COSTS_UI_OVERRIDE_KEY = "ra.costs.ui";

function readOverride() {
  try {
    const v = window.localStorage.getItem(COSTS_UI_OVERRIDE_KEY);
    return v === "v2" || v === "v3" ? v : null;
  } catch (_) {
    // Modo privado / storage bloqueado: sin override, manda el resto de las reglas.
    return null;
  }
}

export function isCostsV3(uid) {
  if (IS_LOCAL) return false;
  const override = readOverride();
  if (override) return override === "v3";
  if (process.env.NODE_ENV === "development") return true;
  if (COSTS_V3_LAUNCH.everyone) return true;
  return !!uid && COSTS_V3_UIDS.includes(uid);
}
